import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../../../environments/environment';
import { AssetsService, UserService } from '../../core';
import { CommonService } from '../../core/services/common.service';
import { VideoPlayerService } from '../../core/services/videoPlayerService';
import { EventTrackingService } from '../../page-services/google/event-tracking.service';
import { LoginRegisterComponent } from '../../auth/login-register/login-register.component';
import { ImageManipulationComponent } from '../../core/components/image-manipulation/image-manipulation.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-item-hover',
  imports: [
    LoginRegisterComponent,
    ImageManipulationComponent,
    CommonModule,
    TranslateModule,
  ],
  templateUrl: './item-hover.component.html',
  styleUrl: './item-hover.component.css',
})
export class ItemHoverComponent {
  @Input() item: any;
  @Input() page_view: string = '';
  @Input() isHovered: boolean = false;
  @Input() isContinueWatching: boolean = false;
  @Input() stopClickPropagation: boolean = false;
  @Input() hoveredAssetCode!: any | null;

  @ViewChild('sharedHoverVideo', { static: false })
  videoRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('hoverContainer', { static: false })
  hoverContainerRef!: ElementRef<HTMLDivElement>;

  userInfo: any;
  username: string = '';
  assets_hover: boolean = false;
  item_hover: boolean = false;
  video_ended: boolean = false;
  previewData: any;
  playermodal: any = [];
  checkPrview: any;
  hoverAndExpend: any;
  isPreviewVideoMuted: boolean = true;
  nameOutsideOverlay: any;
  isStarAnimation: boolean = false;

  asset: any;
  player_debounce_time: any;
  player_debounce_time2: any;
  @Output() addToWatchlist: EventEmitter<any> = new EventEmitter();
  @Output() removeFromWatchlist: EventEmitter<any> = new EventEmitter();
  @Output() deleteContinueWatching: EventEmitter<{ event: Event; item: any }> =
    new EventEmitter();
  @Output() onHoverClick = new EventEmitter<any>();
  @Output() itemClick = new EventEmitter<any>();
  @ViewChild('loginModal') loginModal!: ElementRef;
  starAnimationInterval: any;
  freeIcon: string = environment.freeIcon;
  paidIcon: string = environment.paidIcon;

  page_player: any;
  is_page_player_paused: any;

  firstSegment: string = '';
  modalRef: any;
  play_err: boolean = false;
  videoPlayUrl: any;
  constructor(
    private UserService: UserService,
    private AssetsService: AssetsService,
    public commonService: CommonService,
    private VideoPlayerService: VideoPlayerService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private googleEvent: EventTrackingService
  ) {}

  ngAfterViewInit() {
    // setInterval(() => {
    //   this.isStarAnimation = false;
    //   setTimeout(() => {
    //     this.isStarAnimation = true;
    //   }, 100);
    // }, 9000);
  }

  ngOnInit(): void {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')!)?.result?.user;
    if (this.userInfo) {
      this.username = this.userInfo.username;
    } else {
      this.stopClickPropagation = true;
    }

    // Get the full route URL
    const currentUrl = this.router.url;
    // console.log('Full URL:', currentUrl);

    // Split the URL by slashes and get the first part
    this.firstSegment = currentUrl.split('/')[1]; // Index 1 will give you 'detail'
    // console.log('Route Path:', this.firstSegment); // Outputs: 'detail'

    // console.log('item',this.item);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      localStorage.getItem('item_hover') &&
      (this.hoveredAssetCode?.is_preview == '1' ||
        this.hoveredAssetCode?.series_is_preview == '1')
    ) {
      this.isPreviewVideoMuted = true;
      this.checkPrview = this.hoveredAssetCode?.code;
      const id_mute =
        'video_mute_icon' +
        this.hoveredAssetCode.code +
        this.hoveredAssetCode?.category_slug;

      setTimeout(() => {
        if (!this.videoRef) return;
        document
          .getElementById(id_mute)
          ?.style.setProperty('display', 'none', 'important');
        const videoEl = this.videoRef.nativeElement;
        // console.log('videoEl',videoEl);
        localStorage.setItem('item_hover', '');
        this.item_hover_enter(this.hoveredAssetCode);
        // Set video source dynamically
        // videoEl.src = this.item.preview_video_url; // assign your preview URL
        // videoEl.muted = this.isPreviewVideoMuted;
        // videoEl.play().catch(err => console.warn('Video play failed', err));
      }, 0); // small delay to ensure DOM is rendered
    }
    if (changes['isHovered']) {
      if (changes['isHovered'].currentValue) {
        // console.log('currentValue true');

        this.isStarAnimation = true;
        this.starAnimationInterval = setInterval(() => {
          this.isStarAnimation = false;
          setTimeout(() => {
            this.isStarAnimation = true;
          }, 100);
        }, 9000);
      } else {
        this.isStarAnimation = false;
        clearInterval(this.starAnimationInterval);
      }
    }
    // console.log('ngOnChanges from new hover for', this.item?.name);
    // console.log(this.item?.is_watchlist_added ? 'watchlist_added': 'watchlist_not_added');
  }

  strToLower(str: string) {
    return str?.toLowerCase();
  }

  openLoginModal() {
    //  this.modalRef = this.modalService.open(this.loginModal, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    // }, (reason) => {
    // });
    // Open the modal and assign the modalRef to the returned modal reference
    this.modalRef = this.modalService.open(this.loginModal, {
      ariaLabelledBy: 'modal-basic-title',
    });

    // Handle the modal close or dismiss event if needed
    this.modalRef.result.then(
      (result: any) => {
        // console.log('Modal closed with:', result);
      },
      (reason: any) => {
        // console.log('Modal dismissed with reason:', reason);
      }
    );
  }
  closeLoginModal(modalRef: any) {
    // console.log('modalRefd', this.modalRef);

    this.modalRef.close();
  }

  getAssetDetail(asset: any) {
    let assetDetail = {
      code: asset.code,
      type: asset.type || '',
    };
    let urlEncodedDetail =
      this.UserService.convertoJSONToUrlEncoded(assetDetail);
    this.AssetsService.getAssetDetail(urlEncodedDetail).subscribe(
      (assetDetailRes) => {
        // console.log('assetDetail', assetDetailRes.result);

        // console.log('assetDetailRes from new hover: ', assetDetailRes);
        this.item['assetDetail'] = assetDetailRes.result;
      },
      (error) => {
        // console.error('error fetching asset detail: ', error);
      }
    );
  }

  // Method that handles click events
  handleClick(item: any, event: MouseEvent) {
    // console.log('handleClick item', item);

    if (!this.userInfo) {
      if (this.stopClickPropagation) event.stopPropagation();
      localStorage.setItem('preLoginRoute', this.commonService.detailRoute(item));
      localStorage.setItem('preLoginFullScreen', 'false');
      localStorage.setItem('preLoginContentAvailability', (item.content_availability || 'free').toLowerCase());
      localStorage.removeItem('loginIntent');
      const assetData = {
        redirect_to_detail: true,
        name: item.name,
        code: item.code,
        type: item.type,
      };
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: assetData,
        queryParamsHandling: 'merge',
      });
      this.openLoginModal();
      return;
    }

    // this.route.queryParams.subscribe(queryParams => {
    const queryParams = this.route.snapshot.queryParams;

    // console.log('Query Params:', queryParams); // Access query parameters from the URL
    // console.log('Query Params: length', Object.keys(queryParams).length); // Access query parameters from the URL
    if (
      this.firstSegment === 'detail' &&
      Object.keys(queryParams).length === 0
    ) {
      // console.log('detaildetaildetaildetail');
      if (item.type == 'tvshow') {
        // event.stopPropagation();
        this.itemClick.emit(item);
        // this.redirectUrl(item, event);
      } else {
        this.onHoverClick.emit(item); // Emit the onHoverClick event
      }

      // event.stopPropagation();  // Stop event propagation
    } else if (!queryParams['search']) {
      // console.log('redirect');
      this.redirectUrl(item, event); // Redirect logic
    }

    // });
  }

  redirectUrl(data: any, event: Event, full_screen = false) {
    // remove more like backdrop
    $('#more_like_modal').modal('hide');
    // $('#more_like_small_player').hide();
    $('#more_like_small_player').attr('hidden', true);
    $('#closeMoreLikeThis').click();
    data.continue_watching = false;
    if (this.stopClickPropagation) event.stopPropagation();

    this.userInfo = localStorage.getItem('userInfo');

    // console.log('data', data);
    if (this.userInfo) {
      data['full_screen'] = full_screen;
      let itemForDetailPage = {
        code: data.code,
        type: data.type,
      };
      let pagename = this.strToLower(''); //this.data.category_name
      this.page_view = this.page_view + '_' + pagename.split(/\s/).join('');

      if (
        !full_screen ||
        data.content_availability.toLowerCase() == 'free' || (data.content_availability.toLowerCase() == 'paid' && data?.type == 'episode') || 
        (data.content_availability.toLowerCase() == 'paid' && data?.assetDetail?.is_pack_active == 1)) {
        // check continue watch data for series
        if (
          (data?.category_type || '').toLowerCase() === 'continue-watching' ||
          this.isContinueWatching
        ) {
          data.continue_watching = this.isContinueWatching;
          // data.code = data.series_code;
          // data.name = data.series_name;
        }
        this.commonService.goToDetail(data, this.page_view);
      } else {
        this.commonService.goToDetail(data, this.page_view);
        // document
        //   .querySelectorAll('.modal-backdrop')
        //   .forEach((backdrop) => backdrop.remove());
        // this.router.navigateByUrl('/subscribe');
      }
      // if (data.asset_cat_type == 'recentlywatched') {
      //   this.commonService.goToDetail(data, this.page_view);
      // } else {
      //   this.commonService.goToDetail(data, this.page_view);

      // }
    } else {
      localStorage.setItem('preLoginRoute', this.commonService.detailRoute(data));
      localStorage.setItem('preLoginFullScreen', full_screen ? 'true' : 'false');
      localStorage.setItem('preLoginContentAvailability', (data.content_availability || 'free').toLowerCase());
      localStorage.removeItem('loginIntent');
      const assetData = {
        redirect_to_detail: true,
        name: data.name,
        code: data.code,
        type: data.type,
      };

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: assetData,
        queryParamsHandling: 'merge',
      });
      this.openLoginModal();
    }
  }

  addRemoveFromWatchlist(item: any, button: HTMLButtonElement, event: Event) {
    // console.log('item', item);
    // return;
    event.stopPropagation();
    if (!localStorage.getItem('isAuthenticated')) {
      this.openLoginModal();
      return;
    }
    // button.disabled = true;

    if (!item?.is_watchlist_added || item?.is_watchlist_added == 0) {
      this.googleEvent.eventEmitter(
        'Watchlist',
        'Watchlist',
        this.username + '-' + item.code + '-' + item.name,
        0,
        this.username,
        this.username + '-' + item.code + '-' + item.name
      );
      let params = {
        type: item.type == 'episode' ? 'tvshow' : item.type,
        code: item.type == 'episode' ? item.series_code : item.code,
      };
      this.AssetsService.addToWatchList(params).subscribe(
        (data) => {
          if (data.response_code === 200 || data.response_code === 201) {
            item.is_watchlist_added = 1;
            this.addToWatchlist.emit(item);
          }
          button.disabled = false;
        },
        (error) => {
          console.error('Error adding to watchlist:', error);
          button.disabled = false;
        }
      );
    } else {
      let params = {
        code: item.type == 'episode' ? [item.series_code] : [item.code],
      };
      this.AssetsService.deleteFromWatchlist(params).subscribe(
        (data) => {
          if (data.response_code === 200 || data.response_code === 201) {
            item.is_watchlist_added = 0;
            this.removeFromWatchlist.emit(item);
          }
          button.disabled = false;
        },
        (error) => {
          console.error('Error deleting from watchlist:', error);
          button.disabled = false;
        }
      );
    }
  }

  togglePreviewVideoMute(asset: any, event: any) {
    event.stopPropagation();
    if (this.isPreviewVideoMuted) {
      videojs('hoverPreviewVideo' + asset.code + asset?.category_slug).muted(
        false
      );
      this.isPreviewVideoMuted = false;
      // console.log('muted');

      if (this.page_player && !this.page_player?.paused()) {
        this.page_player.pause();
      }
    } else {
      videojs('hoverPreviewVideo' + asset.code + asset.category_slug).muted(
        true
      );
      this.isPreviewVideoMuted = true;
      if (this.is_page_player_paused) {
        this.page_player.pause();
      } else if (this.page_player) {
        this.page_player.play();
      }
    }
  }

  onMouseEnter(asset: any) {
    const page = this.router.url.replace('/', '');
    const excludedPages = ['home', 'banner-design'];
    if (document.getElementById('player_one')) {
      this.page_player = videojs(document.getElementById('player_one'));
      //  console.log('mouse enter this.page_player',this.page_player);
      if (this.isPreviewVideoMuted) {
        this.is_page_player_paused = videojs(
          document.getElementById('player_one')
        ).paused();
      }
    }
    // console.log('mouse enter',this.page_player);
    // console.log('is_page_player_paused',this.is_page_player_paused);

    if (page && !excludedPages.includes(page)) {
      // alert(55)
      // console.log('page',this.router.url.replace('/', ''));
      // this.hoveredAssetCode =asset;
      // this.item_hover_enter(asset)
    }
  }

  item_hover_enter(asset: any) {
    const suffix = `${this.hoveredAssetCode.code}${this.hoveredAssetCode.category_slug}`;
    const hoverImgId = `asset_hover_img${suffix}`;
    if (this.asset && this.asset?.code != asset?.code) {
      console.log('not match asset code');

      // Show hover image
      this.toggleDisplay(hoverImgId, true);
      this.assets_hover = false;
      // videojs("hoverPreviewVideo" +  this.asset.code +  this.asset?.category_slug).dispose();
      const playerId =
        'hoverPreviewVideo' + this.asset.code + this.asset?.category_slug;

      const player = videojs.getPlayer(playerId);

      if (player) {
        player.dispose();
      }
    }
    if (!this.assets_hover) {
      // Show hover image
      this.toggleDisplay(hoverImgId, true);
      this.assets_hover = false;
      this.checkPrview = 'no';
      // videojs("hoverPreviewVideo" + asset.code + asset?.category_slug).dispose();
    }

    if (!this.asset && this.video_ended) {
      // Show hover image
      this.toggleDisplay(hoverImgId, true);
      // this.checkPrview = 'no';
    }
    const el = document.getElementById(hoverImgId);

    if (el && el.style.display === 'none') {
      console.log('Display is none');
      console.log('this.assets_hover', this.assets_hover);
    }

    if (
      (this.assets_hover && el && el.style.display === 'none') ||
      (el && el.style.display == 'none') ||
      (asset?.type != 'episode' && asset?.is_preview != '1') ||
      (asset?.type == 'episode' && asset?.series_is_preview != '1')
    ) {
      console.log('this.video_ended', this.video_ended);
      console.log('return');
      if (!this.video_ended) {
        // Show hover image
        this.toggleDisplay(hoverImgId, true);
      }
      clearTimeout(this.player_debounce_time);
      clearTimeout(this.player_debounce_time2);
      return;
    }
    clearTimeout(this.player_debounce_time);
    clearTimeout(this.player_debounce_time2);
    let playtimeout = 10;
    // same content play again
    if (this.asset?.code == asset?.code) {
      playtimeout = 10;
    }
    // this.player_debounce_time = setTimeout(() => {
    if (
      (asset?.type != 'episode' && asset?.is_preview == '1') ||
      (asset?.type == 'episode' && asset?.series_is_preview == '1')
    ) {
      this.itemHoverAction(asset);
    }

    // }, playtimeout);
  }

  itemHoverAction(asset: any) {
    this.asset = '';

    // this.asset = asset;
    if (!this.item['assetDetail'] && this.userInfo) {
      // console.log('asset',asset);

      this.getAssetDetail(asset);
    }
    // if (this.item.preview?.length <= 0) {
    //   return;
    // }
    // console.log('this.checkPrview', this.checkPrview);

    // console.log('preview asset', asset);
    // check page player status

    if (document.getElementById('player_one')) {
      this.page_player = videojs(document.getElementById('player_one'));
      //  console.log('this.page_player',this.page_player);

      this.is_page_player_paused = videojs(
        document.getElementById('player_one')
      ).paused();
    }

    // console.log('asset', asset);

    const asset_code =
      asset?.type == 'episode' ? asset?.series_code : asset.code;
    let assetDetail = {
      code: asset_code,
    };

    let assetInfo = this.UserService.convertoJSONToUrlEncoded(assetDetail);

    this.VideoPlayerService.playPreview(assetInfo).subscribe((playObj) => {
      this.previewData = playObj.result;
      // console.log('get preview data', playObj);

      if (
        this.previewData.cloud_front &&
        Object.keys(this.previewData.cloud_front).length > 0 &&
        this.previewData.cloud_front.cloudfront_key_pair_id != '' &&
        this.previewData.cloud_front.video_url != '' &&
        this.previewData.cloud_front.cloudfront_policy != '' &&
        this.previewData.cloud_front.cloudfront_signature != ''
      ) {
        // console.log('play',asset.code);

        this.assets_hover = false;
        this.isPreviewVideoMuted = false;
        this.checkPrview = asset.code;
        this.play_err = false;
        this.playVideo(asset);
      } else {
        console.log('inside else block');
        this.checkPrview = 'no';
        videojs(
          'hoverPreviewVideo' + asset.code + asset?.category_slug
        ).dispose();
      }
    });
  }

  playVideo(asset: any) {
    if (!asset?.code) return;
    const suffix = `${asset.code}${asset.category_slug}`;
    const hoverImgId = `asset_hover_img${suffix}`;
    const videoId = `hoverPreviewVideo${suffix}`;
    const playIconId = `hover_video_play${suffix}`;
    const muteIconId = `video_mute_icon${suffix}`;

    // Show hover image initially
    this.toggleDisplay(hoverImgId, true);
    this.assets_hover = false;

    clearTimeout(this.player_debounce_time2);

    this.player_debounce_time2 = setTimeout(() => {
      this.videoPlayUrl = this.previewData?.cloud_front?.video_url;

      const isLocal = window.location.hostname === 'localhost';
      const srcType = isLocal ? 'video/mp4' : 'application/x-mpegURL';

      if (isLocal) {
        this.videoPlayUrl =
          'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4';
      }

      const sources = [{ src: this.videoPlayUrl, type: srcType }];
      // const el = document.getElementById(videoId);
      // if (!el || !el.isConnected) {
      //   return; // 🚫 Owl detached it
      // }
      // Dispose existing player safely
      //   if (videojs.getPlayer(videoId)) {
      //   videojs.getPlayer(videoId).dispose();
      // }
      // console.log('videoId',videoId);
      // console.log('videoId',videoId)
      // Create player
      this.playermodal = videojs(videoId, {
        autoplay: true,
        muted: true,
        controls: false,
        preload: 'auto',
        fluid: true,
      });

      this.playermodal.src(sources);
      this.playermodal.poster(asset.image_landscape);
      this.playermodal.userActive(false);

      this.bindPlayerEvents(asset, {
        hoverImgId,
        playIconId,
        muteIconId,
      });

      this.playermodal
        .play()
        .catch((err: any) => console.warn('Video play failed:', err));
    }, 100);
  }
  private bindPlayerEvents(
    asset: any,
    ids: { hoverImgId: string; playIconId: string; muteIconId: string }
  ) {
    this.playermodal.on('play', () => {
      this.asset = asset;
      this.assets_hover = true;
      this.isPreviewVideoMuted = true;

      this.toggleDisplay(ids.hoverImgId, false);
      this.toggleDisplay(ids.playIconId, true);

      // console.log('Play started');
    });

    this.playermodal.on('playing', () => {
      this.toggleDisplay(ids.muteIconId, true);
      // console.log('Playing now!');
    });

    this.playermodal.on('error', () => {
      console.error('Preview video error');
      this.resetPreviewState();
    });

    this.playermodal.on('ended', () => {
      if (this.asset?.code !== this.checkPrview) return;
      // console.log('ended');
      // console.log('Preview ended');
      this.toggleDisplay(ids.hoverImgId, true);
      this.toggleDisplay(ids.playIconId, false);

      this.video_ended = true;
      this.resetPreviewState();
    });
  }
  private toggleDisplay(id: string, show: boolean) {
    document
      .getElementById(id)
      ?.style.setProperty('display', show ? 'block' : 'none', 'important');
  }

  private resetPreviewState() {
    this.checkPrview = 'no';
    this.assets_hover = false;
    this.isPreviewVideoMuted = true;
    this.play_err = true;
    this.asset = null;
  }
  item_hover_leave(asset: any) {
    if (!asset?.code) return;
    const suffix = `${asset.code}${asset.category_slug}`;
    const playerId = `hoverPreviewVideo${suffix}`;
    const hoverImgId = `asset_hover_img${suffix}`;

    this.assets_hover = false;
    this.video_ended = false;
    this.isPreviewVideoMuted = true;

    // Show hover image
    this.toggleDisplay(hoverImgId, true);

    clearTimeout(this.player_debounce_time);

    // Resume page player if needed
    // console.log('his.page_player',this.page_player);

    if (!this.is_page_player_paused) {
      this.page_player?.play();
    }

    // Safely dispose preview player
    const player = videojs.getPlayer(playerId);
    if (player && !player.isDisposed()) {
      try {
        player.pause();
        player.dispose();
        // console.log('Disposed preview player:', playerId);
      } catch (err) {
        console.warn('Player dispose failed:', err);
      }
    }

    this.checkPrview = 'no';
    this.asset = null;
  }

  // item_hover_leave(asset: any) {
  //   console.log('leave', asset?.code);

  //   this.assets_hover = false;
  //   // this.item_hover = false;
  //   this.video_ended = false;
  //   const playerId =
  //         "hoverPreviewVideo" + asset.code + asset?.category_slug;
  //          const playerId2 = document.getElementById(playerId);
  //          console.log('playerId2',playerId2);

  //         //  if(playerId) {
  //         //   videojs("hoverPreviewVideo" + asset.code + asset?.category_slug).dispose();
  //         //  }

  //   if (
  //     asset.code == this.checkPrview ||
  //     videojs.getPlayers()[
  //       `hoverPreviewVideo${asset?.code + asset?.category_slug}`
  //     ]
  //   ) {

  //     this.isPreviewVideoMuted = true;
  //     console.log('this.asset?.code',this.asset?.code)
  //     console.log('this.asset?.category_slug',this.asset?.category_slug)
  //     console.log('this.hoveredAssetCode?.code',this.hoveredAssetCode?.code)
  //     // videojs(
  //     //   'hoverPreviewVideo' + this.hoveredAssetCode?.code + this.hoveredAssetCode?.category_slug
  //     // ).pause();

  //     this.assets_hover = false;
  //     console.log('this.assets_hover',this.assets_hover)
  //       const idd =
  //         'asset_hover_img' + asset.code + asset?.category_slug;

  //       document
  //         .getElementById(idd)
  //         ?.style.setProperty('display', 'block','important');
  //     //       const id =
  //     //         'hover_video_play' + this.asset.code + this.asset?.category_slug;
  //     //       document.getElementById(id)?.style.setProperty(
  //     //   'display',
  //     //   'none',
  //     //   'important'
  //     // );
  //     // console.log('video disposed from item_hover_leave: ', 'hoverPreviewVideo', asset.code);
  //     this.checkPrview = 'no';

  //     clearTimeout(this.player_debounce_time);
  //     if (!this.is_page_player_paused) {
  //       this.page_player?.play();
  //     }
  //     // this.video_ended = false;
  //     console.log('asset',asset)
  //      videojs("hoverPreviewVideo" + asset.code + asset?.category_slug).dispose();
  //   }
  // }

  setCookie(cname: any, cvalue: any, exdays: any) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  deleteFromContinueWatching(event: Event, item: any) {
    event.stopPropagation();
    this.deleteContinueWatching.emit(item);
  }

  slugToTitle(slug: string): string {
    return slug
      .replace(/-/g, ' ') // Replace hyphens with spaces
      .replace(/\s+/g, ' ') // Normalize multiple spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
  }
}
